/**
 * Calculate the contrast ratio between two hex colors. The ratio ranges from 1 (no contrast) to 21 (maximum contrast).
 * @param hex1 - The first hex color.
 * @param hex2 - The second hex color.
 * @returns The contrast ratio between the two colors.
 */
export function getContrastRatio(hex1: string, hex2: string): number {
  const lum = (hex: string) => {
    const rgb = parseInt(hex.slice(1), 16);
    return [rgb >> 16, (rgb >> 8) & 255, rgb & 255]
      .map((c) => {
        c /= 255;
        return c <= 0.04045 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
      })
      .reduce((acc, c, i) => acc + c * [0.2126, 0.7152, 0.0722][i], 0);
  };
  const [l1, l2] = [lum(hex1), lum(hex2)].sort((a, b) => b - a);
  return (l1 + 0.05) / (l2 + 0.05);
}
